import React, { useState, useEffect, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useI18next } from "gatsby-plugin-react-i18next"
import Category from "./category"
import { useClickOutside } from "../lib/hooks"

const Sidebar = ({ location, isSidebarOpen, setSidebarOpen }) => {
  const data = useStaticQuery(graphql`
    query SidebarQuery {
      categories: allYaml {
        edges {
          node {
            en {
              description
              name
              slug
              order
              children {
                description
                name
                slug
                order
              }
            }
            es {
              description
              name
              slug
              order
              children {
                description
                name
                slug
                order
              }
            }
          }
        }
      }
      items: allMarkdownRemark {
        edges {
          node {
            frontmatter {
              title
              language
              summary
              category
              order
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)
  const sidebarRef = useRef(null)
  const { language } = useI18next()
  const [items, setItems] = useState([])
  const [categories, setCategories] = useState([])
  useEffect(() => {
    const i = []
    data.items.edges
      .flat()
      .filter(node => node.node.frontmatter.language === language)
      .forEach(node => i.push(node.node))
    setItems(i)

    function addItemsToCategory(cat) {
      cat.items = i
        .filter(node => node.frontmatter.category === cat.slug)
        .sort((a, b) => a.frontmatter.order - b.frontmatter.order)
      if (cat.children) {
        cat.children
          .sort((a, b) => a.order - b.order)
          .map(child => addItemsToCategory(child))
        return cat
      }
      return cat
    }

    const cats = data.categories.edges
      .map(node => node.node[language])
      .filter(node => node)
      .flat()

    cats
      .sort((a, b) => a.order - b.order)
      .map(cat => {
        return (cat = addItemsToCategory(cat))
      })
    setCategories(cats)
  }, [data.items.edges, data.categories.edges, language])
  const iconClasses = "w-6 h-6 block text-tomato hover:stroke-black"

  const handleClickOutside = () => {
    setSidebarOpen(false)
  }
  useClickOutside(sidebarRef, handleClickOutside)
  return (
    <div
      ref={sidebarRef}
      className={`transition w-[300px] z-10 bg-lime flex fixed h-screen ${
        isSidebarOpen
          ? "translate-x-[0vw]  overflow-y-auto"
          : "translate-x-[-300px]"
      }`}
    >
      <div className="w-full">
        {items && (
          <ul className="list pt-12">
            <li>
              <button
                onClick={() => {
                  setSidebarOpen(!isSidebarOpen)
                }}
                className={`rounded-md z-30 cursor-pointer p-1 absolute ${
                  isSidebarOpen ? "right-2" : "-right-10"
                } top-2`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className={iconClasses}
                >
                  {isSidebarOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                    />
                  )}
                </svg>
              </button>
            </li>
            {categories.map((category, index) => (
              <Category category={category} key={index} location={location} />
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default Sidebar
